var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGold({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".8vw",
    height: ".7vw",
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.55693 6.48858L4.55648 6.48809L4.55426 6.48663L4.55693 6.48858ZM13 4.95868L12.0203 2.12008L8.45906 0L1.07919 4.30773L0 7.46524L4.3505 10L4.42197 6.56441L1.03746 4.44823L1.32779 4.61643L1.1622 4.51191L1.75352 4.8561L1.21548 4.51191L4.55648 6.48809L11.7503 2.41614L10.5988 3.10841L11.947 2.3544L9.27855 3.9018L4.6466 6.68595L4.35005 9.99951L12.9996 4.95771L13 4.95868ZM4.70076 5.49733L2.75236 4.35878L4.64749 5.00049L10.4496 2.18085L4.70076 5.49733Z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGold);
export default __webpack_public_path__ + "static/media/gold.ad79519c119673128d56388a9940d4c2.svg";
export { ForwardRef as ReactComponent };